<template>
  <div class="home">
    <div class="title">
      <div>
        我的班級
      </div>
    </div>

    <div class="btns">
      <div>
        <button class="outline" @click="$router.push('/mygrade')">
          <font-awesome-icon icon="star" />
          我的成績
        </button>
      </div>
      <div>
        <button class="outline" @click="$router.push('/myquestions/all');">
          <font-awesome-icon icon="circle-question" />
          我的提問
        </button>
      </div>
      <div>
        <button class="outline" @click="$router.push('/ranklists')">
          <font-awesome-icon icon="ranking-star" />
          排行榜
        </button>
      </div>
    </div>

    <div class="classes">
      <div v-for="i in enrollmentInfo" :key="i.id">
        <div>
          <img :src="require(`../assets/image/${getPhotoName(i.course_english_name)}.png`)" />
        </div>
        <div>
          <div>{{ i.course_chinese_name }}</div>
          <div>{{ i.startDate }} ({{ i.dayOfWeek }}) / {{ i.time }}</div>
          <!-- <div>{{ i.time }}</div> -->
          <div>課程人數：{{ i.people }} 人</div>
          <div v-if="i.acText">{{ i.acText }}</div>
          <div v-if="i.acText" class="progress">
            <div
              class="outside"
              :style="{
                border: parseFloat(i.acRate.toFixed(1)) === 100
                  ? '2px solid #248a4d' : '2px solid #43266d'
              }"
            >
              <div class="bar">
                <div class="left"
                  :style="{
                    flex: parseFloat(i.acRate.toFixed(1)),
                    background: parseFloat(i.acRate.toFixed(1)) === 100 ? '#248a4d' : '#43266d'
                  }"
                  />
                <div class="right" :style="{ flex: 100 - parseFloat(i.acRate.toFixed(1)) }" />
              </div>
            </div>
            <div class="text">
              <div>({{ parseFloat(i.acRate.toFixed(1)) }}%)</div>
            </div>
            <div
              class="onehundred-icon"
              v-if="parseFloat(i.acRate.toFixed(1)) === 100"
            >
              <font-awesome-icon icon="thumbs-up" />
            </div>
          </div>
        </div>
        <div>
          <button
            class="outline"
            @click="$router.push(`/myclass/${i.class_id}?
              course_name=${i.course_english_name}&course_ver=${i.course_ver}`)"
          >
            進入
          </button>
        </div>
      </div>
    </div>
    <Loading />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getMyClassList } from '../assets/api/class';
import { getCommitmentByCwId } from '../assets/api/commitment';
import { getHuntRate } from '../assets/api/cwhunt';
import Loading from '../components/Loading.vue';

export default {
  name: 'Home',
  components: {
    Loading,
  },
  data() {
    return {
      enrollmentInfo: [],
    };
  },
  computed: {
    ...mapState('common', ['user', 'isCommitment']),
  },
  async created() {
    if (this.user.id.includes('TW')) {
      this.$router.push('/classesAndQuestions');
      return;
    }

    if (this.user.id.includes('AW')) {
      this.$router.push('/admin');
      return;
    }

    try {
      if (this.isCommitment === null && this.user.id.includes('SW')) this.getCommitment();

      const { data } = await getMyClassList(this.user.id);

      const apcsCourseId = data.course.map((i) => (i.course_series_name === 'apcs' ? i.id : -1)).filter((i) => i !== -1);
      const acData = apcsCourseId
        .map((i) => getHuntRate(this.getClassIdByCourseId(data.class, i), this.user.id));
      const resData = await Promise.all(acData.map((p) => p.catch((e) => e)));

      data.class.forEach((i, idx) => {
        let acText = null;
        let acRate = null;
        if (apcsCourseId.includes(i.course_id)) {
          const { ac, total, ac_rate } = resData[apcsCourseId.indexOf(i.course_id)].data;
          acText = `解題數：${ac} / 總題數：${total}`;
          acRate = ac_rate * 100;
        }
        this.enrollmentInfo.push({
          class_id: i.id,
          course_id: data.course[idx].id,
          startDate: i.start_date,
          time: i.time,
          people: i.class_item.length,
          course_chinese_name: data.course[idx].course_chinese_name,
          course_english_name: data.course[idx].course_english_name,
          course_ver: data.course[idx].course_version,
          dayOfWeek: i.day_of_the_week,
          acText,
          acRate,
        });
      });
    } catch {
      //
    } finally {
      //
    }
  },
  methods: {
    async getCommitment() {
      try {
        await getCommitmentByCwId(this.user.id);
        this.$store.commit('common/SET_COMMITMENT_STATUS', true);
      } catch {
        this.$store.commit('common/SET_COMMITMENT_STATUS', false);
      }
    },
    getClassIdByCourseId(enrollmentInfo, courseId) {
      return enrollmentInfo.find((i) => i.course_id === courseId).id;
    },
    getPhotoName(courseName) {
      let name;
      const level = courseName.split('-')[1];

      if (level.includes('0')) name = 'course0';
      else if (level.includes('1')) name = 'course1';
      else if (level.includes('2')) name = 'course2';
      else if (level.includes('2')) name = 'course3';
      else name = 'course0';

      return name;
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  position: relative;
  padding-bottom: 40px;

  .title {
    display: flex;
    justify-content: center;

    > div {
      position: absolute;

      width: 200px;
      height: 70px;
      padding-top: 10px;
      font-size: 20px;
      background: url('../assets/image/studentBtn.png');
      background-size: contain;
      background-repeat: no-repeat;
      text-align: center;
    }
  }

  > div {
    &:first-child {
      > div {
        top: -20px;
      }
    }
  }

  .btns {
    display: flex;
    position: absolute;
    right: 5%;
    top: -60px;

    > div {
      margin-left: 10px;

      button {
        padding: 8px 20px;
      }
    }
  }

  .classes {
    display: flex;
    // justify-content: center;
    flex-wrap: wrap;
    margin: 70px 0 20px 0;
    padding: 0 50px;
    // margin: 30px 25px 0;

    @media (max-width: 768px) {
      flex-direction: column;
    }

    .progress {
      .onehundred-icon {
        right: 90px;
      }
    }

    &.other {
      margin-top: 90px;
    }

    > div {
      position: relative;

      margin-right: 36px;
      margin-bottom: 50px;
      width: calc((100% - 72px) / 3);
      // max-width: 300px;

      @media (max-width: 768px) {
        width: 100%;
      }

      border-radius: 20px;
      box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.5);
      border: 3px solid #000;
      background-color: #fff;

      padding: 5px 15px 40px;

      &:nth-child(3n + 3) {
        margin-right: 0;
      }

      > div {
        &:first-child {
          display: flex;
          justify-content: center;
          border-bottom: 1px solid #000;

          img {
            width: 70%;
          }
        }

        &:nth-child(2) {
          padding-top: 15px;

          > div {
            text-align: center;
            margin-bottom: 10px;

            &:first-child {
              font-size: 30px;
              font-weight: bold;
              color: $main-purple;
            }

            &:nth-child(n + 2) {
              font-size: 20px;
              color: #000;
              font-weight: normal;
            }

            &:last-child {
              margin: 0;
            }
          }
        }

        &:last-child {
          position: absolute;
          left: calc(50% - 93px);
          bottom: -25px;
          width: 186px;

          button {
            font-size: 25px;
            height: 50px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
            border: solid 3px #000000;
          }
        }
      }
    }
  }

  .acRate {
    padding: 0 20px;
  }
}
</style>
